module.exports = __webpack_public_path__ + "img/txt_series_102.67156059.png";